import {defaultItemPerPage} from "domain/enum/pagination";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

export function getStockEasyLink(retailerId) {
    const params = encodeURIComponent("&retailer.id=" + decodeURIComponent(retailerId).replace("/retailers/", "") + "&order[updatedAt]=desc&pagination=true&itemsPerPage=" + defaultItemPerPage + "&page=1&status=true");
    return `${MarketplaceRoutes.STOCK_EASY_SHOW_RETAILER_PRODUCTS(retailerId)}/${params}`;
}
